import React from 'react';  
import { HeaderTabs } from './HeaderElement/HeaderTabs';
const Header = () => {
    return (
        <div className='header'>
        <HeaderTabs /> 
        </div>
 
    );
}

export default Header;
